import React, { Component } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../environment';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { CircularProgress, Typography } from '@material-ui/core';

import { useStyles } from './styles.js';

class ChapterStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { classes } = this.props;

    return (
      <QueryRenderer
        environment={environment}
        variables={this.props.variables}
        query={graphql`
          query ChapterStatusQuery($args: pickemGameQuestionAnswerInputType) {
            getGuestGameQuestionAnswerCount(arguments: $args) {
              code
              message
              data {
                current_chapter_data {
                  chapter_id
                  number_of_questions
                  number_of_tiebreaker_questions
                  number_of_answered_questions
                  number_of_answered_tiebreaker
                  number_of_correct_answers
                }
              }
            }
          }
        `}
        render={({ error, props }) => {
          if (error) {
            return <div>No Records Found.</div>;
          } else if (props) {
            let guest_answer_count =
              props.getGuestGameQuestionAnswerCount.data.current_chapter_data;
            return (
              <Typography
                key={`ChapterActive${this.props.variables.args.quarter_id}`}
                className={classes.activeChapter}
              >
                {/**Subtracting 1 from questions count because there is no
                 *  tiebreaker question for Waste Management */}
                {guest_answer_count &&
                guest_answer_count.number_of_questions - 1 ==
                  guest_answer_count.number_of_answered_questions
                  ? 'SUBMITTED'
                  : this.props.active
                  ? 'ACTIVE'
                  : ' '}
              </Typography>
            );
          } else {
            return <CircularProgress className={classes.progress} />;
          }
        }}
      />
    );
  }
}

ChapterStatus.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(ChapterStatus);
